<template>
  <div class="hidden">
    <div id="login-box" ref="loginBox">
      <form>
        <label for="login-username">Email: </label>
        <span v-if="error" style="color: red; padding-left: 30px;">{{
          error
        }}</span>
        <input
          id="login-username"
          v-model="username"
          type="text"
          name="login_username"
        />
        <label for="login-password">Password:</label>
        <input
          id="login-password"
          v-model="password"
          type="password"
          name="login_password"
        />
        <div class="submit-block">
          <span>
            <input
              id="login-submit"
              type="submit"
              name="submit"
              value="Login"
              class="big-btn grey"
              @click.prevent="login"
            />
          </span>
        </div>
        <a class="lostpass" @click.prevent="reset">Forgot password?</a>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      error: "",
    };
  },
  mounted() {
    const savedUsername = localStorage.getItem('sts_username');
    if (savedUsername) {
      this.username = savedUsername;
    }
  },
  methods: {
    login() {
      if (!this.username || !this.password) return;
      this.$store
        .dispatch("login", { email: this.username, password: this.password })
        .then((user) => {
          localStorage.setItem('sts_username', this.username);
          this.username = "";
          this.password = "";
          document.querySelector("#fancybox-close").click();
          this.error = "";
          this.$root.$refs.toastr.s("Login Successful");
        })
        .catch(() => {
          this.error = "Login Failed";
        });
    },
    reset() {
      document.querySelector("#fancybox-close").click();
      this.$router.push("/forgotpassword");
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// login.vue?92dfa1b2